import React from "react";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import { isOnlyId } from "@/utils/URL";
import { useRouter } from "next/router";
import SubjectList, { subjectListGetServerSideProps } from "./SubjectList";
import SubjectDetail, {
  subjectDetailGetServerSideProps,
} from "./SubjectDetail";

const SubjectAdaptor = (
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) => {
  const { onlyId: _onlyId, data, ...restProps } = props;
  const router = useRouter();
  let onlyId = _onlyId;
  // 浏览器的回退/前进功能，不会走到 getInitialProps 钩子，此时 onlyId 拿不到任何值
  if (onlyId == undefined) {
    onlyId = isOnlyId(router.query.bookId);
  }

  return onlyId ? (
    <SubjectDetail {...data} {...restProps} />
  ) : (
    <SubjectList {...data} {...restProps} />
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx, ...args) => {
  const onlyId = isOnlyId(ctx.query.cate);

  /**
   * 纯id为话题详情页
   * 非纯id为话题列表页
   */
  const result = onlyId
    ? await subjectDetailGetServerSideProps(ctx, ...args)
    : await subjectListGetServerSideProps(ctx, ...args);

  return {
    ...result,
    props: {
      onlyId,
      data: (result as any).props,
    },
  };
};

export default SubjectAdaptor;
